import { Input } from 'antd'
import React from 'react'
import { Text, View } from 'styles/reactnative'

const SettingMultiInput = ({
	title,
	content,
	fValue,
	setFValue,
	sValue,
	setSValue,
}: any) => {
	return (
		<View
			style={{
				height: 45,
				width: '100%',
				borderBottom: '1px solid #ddd',
				justifyContent: 'space-between',
				padding: 3,
				flexDirection: 'row',
			}}>
			<View style={{ flexDirection: 'row', width: '45%' }}>
				<Text
					style={{
						letterSpacing: 2,
						width: '30%',
						fontWeight: '300',
						color: '#aaa',
					}}>
					{title}
				</Text>
				<Input
					style={{ height: 30, width: '70%', marginLeft: 10 }}
					value={fValue}
					placeholder={title ? title : '-'}
					onChange={e => {
						setFValue(e.target.value)
					}}
				/>
			</View>
			<View style={{ flexDirection: 'row', width: '45%' }}>
				<Text
					style={{
						letterSpacing: 2,
						width: '30%',
						fontWeight: '300',
						color: '#aaa',
					}}>
					{content}
				</Text>
				<Input
					style={{ height: 30, width: '70%', marginLeft: 10 }}
					value={sValue}
					placeholder={title ? title : '-'}
					onChange={e => {
						setSValue(e.target.value)
					}}
				/>
			</View>
		</View>
	)
}

export default SettingMultiInput
